import { OrderPayment } from '../../../models';
import { orderPaymentStatusTranslate } from '../../../static/orderStatus';

export const ACTIONS = {
  END_DATE: 'END_DATE',
  START_DATE: 'START_DATE',
  ALLY: 'ALLY',
} as const;

export const tableHeaders = [
  { title: 'Producto', value: 'product' },
  { title: 'Precio', value: 'price' },
  { title: 'SKU', value: 'sku' },
  { title: 'Status', value: 'status' },
  { title: 'Fecha de pago', value: 'paymentDate' },
];

export function filterOrderPaymentsByDate(
  orderPayments,
  startDate: string,
  endDate: string
) {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : start;

  return orderPayments.filter((orderPayment) => {
    const createdAt = new Date(orderPayment.createdAt);
    return createdAt >= start && createdAt <= end;
  });
}

export function dataConstructor(orderPayments: OrderPayment[]) {
  return orderPayments.map((orderPayment) => ({
    product: orderPayment.orderProduct.product.title,
    price: orderPayment.orderProduct.price,
    sku: orderPayment.orderProduct.sku,
    status: orderPaymentStatusTranslate[orderPayment.paymentStatus],
    ...(orderPayment.paymentStatus === 'paid'
      ? {
          paymentDate: new Date(orderPayment.paymentDate).toLocaleDateString(),
        }
      : {}),
  }));
}
